import styles from './BottinaButton.module.scss';
import bottina from '@components/images/bottina.include.svg';
import React from 'react';
import { Content, Image } from '@wienenergiegithub/ui-next';
import { useTranslation } from '@wienenergiegithub/modules-next/hooks';
import PropTypes from 'prop-types';

const BottinaButton = ({ onClick }) => {
  const { t } = useTranslation('helpwidget');

  return (
    <button className={styles.bottina} onClick={onClick} type="button">
      <div className={styles.bottinaHeader}>
        <div className={styles.bottinaImage}>
          <Image alt="" src={bottina} />
        </div>
        <Content className={styles.bottinaIntro} withParser>
          {t('bottinaIntro')}
        </Content>
      </div>
      <div className={styles.bottinaFooter}>
        <div className={styles.blueCircle}>
          <span className={styles.line} />
          <span className={styles.line} />
          <span className={styles.line} />
        </div>
        <Content className={styles.bottinaQuestion}>
          {t('bottinaQuestion')}
        </Content>
      </div>
    </button>
  );
};

BottinaButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default BottinaButton;
